export default __webpack_public_path__ + "static/media/trash.4dbfb26f.svg";